/* Product story photo slider - see snippets/product-story.liquid
 *
 * Desktop scatters the four photos as an absolutely positioned overlap. Mobile turns the same
 * markup into a slider, so slick is only initialised below the breakpoint and destroyed again
 * above it - otherwise slick's inline styles fight the scatter.
 *
 * jQuery is global in theme.liquid and slick is loaded by the snippet, both deferred, so both
 * are present by the time this runs. The guard keeps it silent if either fails to load. */
(function () {
  var BREAKPOINT = 989;
  var SELECTOR = '.product-story__media';
  var AUTOPLAY_SPEED = 4000;
  // Below this the story stacks; between here and BREAKPOINT it is two columns.
  var TWO_COL_MIN = 750;

  // Auto-advancing content is a problem for anyone who has asked the system to reduce motion,
  // so honour that setting rather than autoplaying unconditionally. Everything else about the
  // slider is unchanged for them - it just waits to be swiped.
  function reducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  // In the two-column range the copy sits beside the carousel, and its scroll area is meant to
  // be exactly as tall as the photos. That cannot be done in CSS: both are grid items in the
  // same row, and the copy is long - that is why it scrolls - so it would always be the one
  // driving the row height rather than following it. The carousel's height is only known once
  // slick has laid out and written it, so it is read back and applied here.
  //
  // At every other width the inline height is cleared, handing the value back to
  // --story-body-max-height in the stylesheet.
  function matchCopyToPhotos($) {
    var twoCol = window.matchMedia(
      '(min-width: ' + TWO_COL_MIN + 'px) and (max-width: ' + BREAKPOINT + 'px)'
    ).matches;

    $('.product-story').each(function () {
      var $story = $(this);
      var $body = $story.find('.product-story__body').first();
      var $media = $story.find(SELECTOR).first();
      if (!$body.length || !$media.length) return;

      if (!twoCol) {
        $body.css('height', '');
        return;
      }

      var h = $media.outerHeight();
      if (h) $body.css('height', h + 'px');
    });
  }

  function sliderable($el) {
    // One photo is not a slider, and an un-populated metafield can leave fewer than four.
    return $el.children('.product-story__photo').length > 1;
  }

  function sync() {
    var $ = window.jQuery;
    if (!$ || !$.fn || !$.fn.slick) return;

    var isMobile = window.matchMedia('(max-width: ' + BREAKPOINT + 'px)').matches;

    $(SELECTOR).each(function () {
      var $el = $(this);
      var initialised = $el.hasClass('slick-initialized');

      if (isMobile && !initialised && sliderable($el)) {
        $el.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
          adaptiveHeight: true,
          autoplay: !reducedMotion(),
          autoplaySpeed: AUTOPLAY_SPEED,
          // Stop advancing while someone is reading or tabbing through a slide.
          pauseOnHover: true,
          pauseOnFocus: true,
        });
      } else if (!isMobile && initialised) {
        // unslick restores the original markup so the desktop scatter works again.
        $el.slick('unslick');
      }
    });

    // A frame later, so slick has written its own height before it is read back.
    window.requestAnimationFrame(function () {
      matchCopyToPhotos($);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }

  // Re-evaluate on resize, debounced - crossing the breakpoint has to init or destroy.
  var t;
  window.addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(sync, 200);
  });

  // slick fires setPosition whenever it re-measures - on init, on resize, and as
  // adaptiveHeight settles. Following it keeps the copy in step without polling.
  if (window.jQuery) {
    window.jQuery(document).on('setPosition', SELECTOR, function () {
      matchCopyToPhotos(window.jQuery);
    });
  }

  document.addEventListener('shopify:section:load', sync);
})();
